<div class="modal-msg">
  <h1 *ngIf="data.titulo">{{data.titulo}}</h1>
  <svg class="icon-close-msg" mat-dialog-close (click)="closeWithOk()">
    <use xlink:href="#icon-close"></use>
  </svg>
  <div *ngIf="data.titulo == undefined" class="alert">
    <svg *ngIf="data.alert" [ngClass]="{'icon-alert': true, 'icon-info': data.informacion}">
      <use xlink:href="#hs-alert"></use>
    </svg>
    <svg *ngIf="!data.alert" class="icon-ok">
      <use xlink:href="#hs-tick-circle"></use>
    </svg>
    <h3>{{data.mensaje}}</h3>
  </div>
  <div *ngIf="data.titulo">
    <div class="titulo-container">
      <svg *ngIf="data.alert" class="icon-alert">
        <use xlink:href="#hs-alert"></use>
      </svg>
      <svg *ngIf="!data.alert" class="icon-ok">
        <use xlink:href="#hs-tick-circle"></use>
      </svg>
      <h3 class="h3-mensaje">{{data.mensaje}}</h3>
    </div>
    <div class="boton-container">
      <app-boton-accion (click)="closeWithOk()" [id]="data.textoConfirmacion" [titulo]="data.textoBoton" [cancelar]="true" [outline]="true"></app-boton-accion>
    </div>
  </div>

</div>
